/**
 * Global
 * ------
 */

/*Initialize popovers*/
$(function () {
    $('[data-toggle="popover"]').popover()
})

$('.hero-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 7000,
});

var setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
  
var getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

$(document).ready(function() {
    if (getCookie("alert-banner") !== "closed") {
        $('#alert-banner').show();
    }
});

$("#alert-banner .close").on('click', function(e) {
    e.preventDefault();
    $('#alert-banner').slideToggle();
    setCookie("alert-banner", "closed", 7)
});


$(".primary-nav .parent-nav a").on('click', function(e) {
    e.preventDefault();
    if( $(window).width() > 992 ) {
        $(this).closest('.nav-item').find('.sub-menu').fadeToggle();
    }
    else {
       $(this).closest('.nav-item').find('.sub-menu').toggle();
    }
});

$(".primary-nav .parent-nav .sub-menu a").on('click', function(e) {
    e.preventDefault();
    console.log("subnav");
    window.location = $(this).attr('href');
});

$(document).mouseup(e => {
   if (!$('.primary-nav .parent-nav').is(e.target) // if the target of the click isn't the container...
   && $('.primary-nav .parent-nav').has(e.target).length === 0) // ... nor a descendant of the container
   {
     $('.primary-nav .sub-menu').hide();
  }
 });


/*Force resize on tab nav click*/
$('.tabs-primary .nav-link').on('shown.bs.tab', function (e) {
    $(window).resize();
});

$("#bio-link").on('click', function(event) {
    event.preventDefault();
    $('#bio-info').slideToggle();
    $('.detail-more').toggle();
    $('.detail-close').toggle();
});

$(".modal-button").on('click', function(event) {
    event.preventDefault();
    console.log('clicked');
    $('#landmarkModal .modal-body .video-embed').html();
    var embed = $(this).attr("data-content");
    $('#landmarkModal .modal-body .video-embed').html(embed);
    $('#landmarkModal').modal('show');
});

$(".modal-form-button").on('click', function(event) {
    event.preventDefault();
    ///var formID = $(this).attr("data-modal-id");
    //$('#' + formID).modal('show');
    $('#landmarkFormModal').modal('show');
});

$('#landmarkModal').on('hidden.bs.modal', function () {
	console.log("hidden");
	$('#landmarkModal .modal-body .video-embed').html('');
});


$(".inline-button").on('click', function(event) {
    event.preventDefault();
    $this = $(this);

    $this.find('.video-overlay').addClass('is-active');
    $this.find('.bg-img').addClass('is-inactive');
});


// EBOOK FORM

$('#ca-resident').change(function() {
    $('.ca-note').slideToggle();
});


// Fade out content overlay when playing wistia video inside the video block
$('.video-block .wistia_embed').on('click', function() {
    $(this).closest('.video-block').find('.content-overlay').fadeOut();
});
